// extracted by mini-css-extract-plugin
export default {"button":"review-module__button__gQHJ5","buttonMobile":"review-module__buttonMobile__GoCDm"};